/**
 * The binary rows lifted from the Bitwize mark — "the Dissolve" silhouette is
 * built out of these same bytes. Shared by `Dissolve` (a static fill for dark
 * panels) and `AmbientBackground` (a slow-drifting site-wide texture) so both
 * pull from one hand-written source rather than drifting apart.
 *
 * A fixed, hand-written set rather than `Math.random()`: a random pattern
 * generated at render time would differ between the server and the client and
 * fail hydration. Cycling a static set gets the same visual texture for free.
 */
export const BIT_ROWS = [
  '01001101 01101111 01100100 01110101',
  '01101100 01100101 00100000 01100010',
  '01110101 01101001 01101100 01110100',
  '00100000 01110100 01101111 00100000',
  '01101100 01100001 01110011 01110100',
  '01001101 01100101 01110010 01101001',
  '01100100 01101001 01100001 01101110',
  '01000010 01100001 01101110 01101011',
  '01000100 01101001 01100111 01101001',
  '01110100 01100001 01101100 00100000',
  '01000011 01100001 01110010 01100111',
  '01101111 01100110 01101100 01101111',
  '01000001 01110100 01101100 01100001',
  '01110011 00100000 01010010 01100101',
] as const;
